export const AWS_Access_Key_Id = () => {
  let AWSFromENV = process.env.React_App_User_AWS_Access_Key_Id;
  let AWSFromLocalStorage = JSON.parse(
    localStorage.getItem("BucketCredential")
  );
  if (AWSFromLocalStorage) {
    return AWSFromLocalStorage.AccessKey;
  } else {
    return AWSFromENV;
  }
};

export const AWS_Secret_Access_Key = () => {
  let AWSFromENV = process.env.React_App_User_AWS_Secret_Access_Key;
  let AWSFromLocalStorage = JSON.parse(
    localStorage.getItem("BucketCredential")
  );
  if (AWSFromLocalStorage) {
    return AWSFromLocalStorage.SecretAccessKey;
  } else {
    return AWSFromENV;
  }
};

export const AWS_Bucket_Name = () => {
  let AWSFromENV = process.env.React_App_AWS_Bucket_Name;
  let AWSFromLocalStorage = JSON.parse(
    localStorage.getItem("BucketCredential")
  );
  if (AWSFromLocalStorage) {
    return AWSFromLocalStorage.BucketName;
  } else {
    return AWSFromENV;
  }
};

export const AWS_Region = () => {
  let AWSFromENV = process.env.React_App_AWS_Region;
  let AWSFromLocalStorage = JSON.parse(
    localStorage.getItem("BucketCredential")
  );
  if (AWSFromLocalStorage) {
    return AWSFromLocalStorage.Region;
  } else {
    return AWSFromENV;
  }
};

export const AWS_Access_Key_Id_Encypt = () => {
  let AWSFromENV = process.env.React_App_User_AWS_Access_Key_Id_encypt;
  let AWSFromLocalStorage = JSON.parse(
    localStorage.getItem("BucketCredentialEncypt")
  );
  if (AWSFromLocalStorage) {
    return AWSFromLocalStorage.AccessKey;
  } else {
    return AWSFromENV;
  }
};

export const AWS_Secret_Access_Key_Encypt = () => {
  let AWSFromENV = process.env.React_App_User_AWS_Secret_Access_Key_encypt;
  let AWSFromLocalStorage = JSON.parse(
    localStorage.getItem("BucketCredentialEncypt")
  );
  if (AWSFromLocalStorage) {
    return AWSFromLocalStorage.SecretAccessKey;
  } else {
    return AWSFromENV;
  }
};
